import gql from 'graphql-tag';
import { graphql } from 'react-apollo';
import { DOWNLOAD_REPORT } from '../../common/GqlAPI';

const APPROVAL_REQUEST = gql`
  query approvalRequests($type: approvalProcess!, $limit: Int, $offset: Int, $filter: FilterInput) {
    approvalRequests(type: $type, limit: $limit, offset: $offset, filter: $filter) {
      rows {
        id
        processId
        createdBy
        requestedBy
        requestedTo
        active
        status
        categoryChangeData {
          outletId
          currentCategoryId
          CurrentCategory {
            title
          }
          proposedCategoryId
          ProposedCategory {
            title
          }
          RetailOutlet {
            title
            averageSales
            Route {
              title
            }
            Town {
              title
            }
          }
        }
      }
      count
    }
  }
`;

const BULK_UPDATE_APPROVAL_REQUEST = graphql(
  gql`
    mutation ($ids: [Int]!, $processId: Int!, $status: approvalStatus!) {
      bulkUpdateApprovalRequest(ids: $ids, processId: $processId, status: $status) {
        success
        failed
      }
    }
  `,
  {
    props: ({ mutate }) => ({
      bulkUpdateApprovalRequest: (variables) =>
        mutate({
          variables,
        }),
    }),
  },
);

const query = {
  approvalRequests: APPROVAL_REQUEST,
};

const mutation = {
  bulkUpdateApprovalRequest: BULK_UPDATE_APPROVAL_REQUEST,
  downloadReport: DOWNLOAD_REPORT,
};

export {
  query, mutation, BULK_UPDATE_APPROVAL_REQUEST, DOWNLOAD_REPORT
};
